import styles from './ErrorPage.module.scss';

export const ErrorPage = () => {
	return (
		<div className={styles['error']}>
			<h1>Oops! Something went wrong.</h1>
			<p>
				We're sorry, but it looks like something went wrong on our end.
				Please try refreshing the page in a few moments, or contact
				support.
			</p>
			<p>Thank you for your patience!</p>
		</div>
	);
};
